import {
  Component,
  input,
  OnInit,
  output,
  ChangeDetectionStrategy,
  effect,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-duplicate-setup',
  templateUrl: './modal-duplicate-setup.html',
  styleUrl: './modal-duplicate-setup.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalDuplicateSetup implements OnInit {
  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly routes = input<any>();
  readonly title = input<string>('setup.modal.duplicateSetup.title');
  readonly nameLabel = input<string>('setup.modal.duplicateSetup.nameNewRoute');
  readonly defaultName = input<string>('');
  readonly loading = input<boolean>(false);
  readonly action = output<any>();

  public images = images;

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json',
  };

  public routeSelected = 0;

  public formGroup: FormGroup = new FormGroup({});

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
    private activatedRoute: ActivatedRoute,
  ) {
    effect(() => this.formGroup.get('name')?.setValue(this.defaultName()));
  }

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe(async (params) => {
      this.routeSelected = Number(params.get('routeId'));
    });
    this.setControls();
    this.formGroup.get('route')?.setValue(this.routeSelected);
  }

  setControls() {
    this.formGroup.addControl(
      'name',
      new FormControl(this.defaultName(), [Validators.required]),
    );
    if (!this.routes()) return;
    this.formGroup.addControl(
      'route',
      new FormControl('', [Validators.required]),
    );
  }

  setSetupName(event: any) {
    this.formGroup.get('name')?.setValue(event.target.value);
  }

  setRoute(event: any) {
    this.formGroup.get('route')?.setValue(event.value);
  }

  onSubmit() {
    this.action.emit({
      name: this.formGroup.get('name')?.value,
      route: this.formGroup.get('route')?.value,
    });
    this.resetForm();
  }

  close() {
    this.modal()?.hide();
    this.resetForm();
  }

  private resetForm() {
    this.formGroup.get('name')?.setValue(this.defaultName());
    this.formGroup.get('route')?.setValue(this.routeSelected);
  }
}
